module.exports = __webpack_public_path__ + "img/li-bg1.12748e4d.png";